import { Routes } from '@angular/router';
import { MainPage } from './pages/main-page/main-page';
import { AboutPage } from './pages/about-page/about-page';
import { ProjectPage } from './pages/project-page/project-page';


export const routes: Routes = [
  { path: '', component: MainPage },
  { path: 'about', component: AboutPage },
  { path: 'projects/:slug/:view', component: ProjectPage },
  { path: '**', redirectTo: '' },
];
